import { ScheduleListAPIData } from "Requests/SchedulePartners";
import { Loader } from "Components/Loader";
import { OrderListItem } from "./OrderListItem";

interface OrdersListProps {
  orderList?: ScheduleListAPIData[];
  loading: boolean;
  onSelectOrderId: (id: number) => void;
}

const columns = [
  {
    title: "Nº do agendamento",
    key: "acuity",
  },
  {
    title: "Nome completo",
    key: "name",
  },
  {
    title: "E-mail",
    key: "email",
  },
  {
    title: "Data",
    key: "date",
  },
  {
    title: "Horário",
    key: "time",
  },
  {
    title: "Detalhes",
    key: "empty",
  },
];

export const OrderList = ({
  orderList,
  loading,
  onSelectOrderId,
}: OrdersListProps) => {
  return (
    <table className="table-content small-separate details">
      <thead>
        <tr>
          {columns.map((columnsItem) => (
            <th key={columnsItem.key}>{columnsItem.title}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {orderList &&
          orderList?.length >= 1 &&
          orderList?.map((orderItem) => (
            <OrderListItem
              order={orderItem}
              key={orderItem.id}
              onSelectOrderId={() => onSelectOrderId(orderItem.acuity_id)}
            />
          ))}

        {orderList && orderList.length == 0 && (
          <tr>
            <td colSpan={7} className="text-center text-purple">
              Oops! Parece que nada foi encontrado...
            </td>
          </tr>
        )}

        {loading && (
          <tr>
            <td colSpan={7} className="text-center">
              <Loader />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
